import { useState } from "react";
import API_URL from '../../../utils/api';
export default function useIntelliMeMatch() {
  const [status, setStatus] = useState("idle"); // idle | creating | queueing | matched | error
  const [sessionId, setSessionId] = useState(null);
  const [pairId, setPairId] = useState(null);
  const [meetLink, setMeetLink] = useState(null);
  const [error, setError] = useState("");
  // Join an existing session (after user confirms)
  // Join an existing session (after user confirms)
  const joinExisting = async (user, suggested) => {
    try {
      const res = await fetch(`${API_URL}/api/match/join-existing`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: user.id || user.uid,
          userName: user.name,
          sessionId: String(suggested.sessionId),
          sessionName: suggested.sessionName
        })
      });
      const data = await res.json();
      if (data.matched) {
        setPairId(data.pairId);
        setMeetLink(data.meetLink);
        setStatus("matched");
        return { pairId: data.pairId, meetLink: data.meetLink };
      } else {
        setStatus("queueing");
        return null;
      }
    } catch (e) {
      setError("Failed to join session");
      setStatus("error");
      return null;
    }
  };
  // Create session
  const createSession = async (sessionName, user) => {
    setStatus("creating");
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/sessions`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: sessionName,
          host: user.name,
          hostId: String(user.id || user.uid),
          members: [{ name: user.name, user_id: String(user.id || user.uid) }]
        })
      });
      const data = await res.json();
      if (res.ok && data.id) {
        setSessionId(data.id);
        return data.id;
      } else {
        setError(data.message || "Failed to create session");
        setStatus("error");
        return null;
      }
    } catch (e) {
      setError("Failed to create session");
      setStatus("error");
      return null;
    }
  };
  // Join matchmaking queue
  const joinQueue = async (sessionId, user, sessionName) => {
    setStatus("queueing");
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/match/join-queue`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          sessionId: String(sessionId),
          userId: user.id || user.uid,
          userName: user.name,
          sessionName
        })
      });
      const data = await res.json();
      if (data.matched) {
        setPairId(data.pairId);
        setMeetLink(data.meetLink);
        setStatus("matched");
        return { pairId: data.pairId, meetLink: data.meetLink };
      } else {
        setStatus("queueing");
        return null;
      }
    } catch (e) {
      setError("Failed to join queue");
      setStatus("error");
      return null;
    }
  };
  return {
    status,
    sessionId,
    pairId,
    meetLink,
    error,
    createSession,
    joinQueue,
    joinExisting
  };
}
